import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ProgramAgregatedRisksComponent } from './program-agregated-risks.component';
import { DxDataGridModule } from 'devextreme-angular';
import { I18nModule } from "app/shared/i18n/i18n.module";
import { MaterialModule } from 'app/material.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CurrencyFormatterPipeModule } from 'app/shared/currency-formatter-pipe/currencyFormatterPipe.module';
import { ProgramAgregatedRisksRoutingModule } from './program-agregated-risks-routing.module';

@NgModule({
  imports: [
    CommonModule,
    DxDataGridModule,
    I18nModule,
    MaterialModule,
    FormsModule,
    NgxSpinnerModule,
    CurrencyFormatterPipeModule,
    ProgramAgregatedRisksRoutingModule
  ],
  declarations: [
    ProgramAgregatedRisksComponent
  ]
})
export class ProgramAgregatedRisksModule { }
